module.exports = __webpack_public_path__ + "img/product_40.3c74e87.webp";